import React from 'react';
import './DailyLoginRewardHistoryItem.css';
import PageButton from '../elements/PageButton/PageButton';
import {resolveDailyLoginRewardDisplay} from '../../utils/dailyLoginRewards/resolveDailyLoginRewardDisplay';
import {formatMatchDate} from '../../utils/date/formatMatchDate';

function DailyLoginRewardHistoryItem({claim, showUserName, onClick, pageId, buttonId}) {
  const {name, iconPath, isNumens, isCrystals} = resolveDailyLoginRewardDisplay(claim.reward);

  const content = (
    <>
      {iconPath && (
        <img className="daily-login-reward-history-icon" src={iconPath} alt={name} title={name}/>
      )}
      <div className="daily-login-reward-history-info">
        <span
          className={`daily-login-reward-history-name ${isNumens ? 'text-coins' : isCrystals ? 'text-crystals' : ''}`}
        >
          {name}
        </span>
        {showUserName && claim.userName && (
          <span className="daily-login-reward-history-user-name">{claim.userName}</span>
        )}
      </div>
      <span className="daily-login-reward-history-streak" title="День подряд">{`${claim.streak} дн.`}</span>
      <span className="daily-login-reward-history-date">{formatMatchDate(claim.createdAt)}</span>
    </>
  );

  if (onClick) {
    return (
      <PageButton
        className="daily-login-reward-history-item daily-login-reward-history-item_clickable"
        onClick={onClick}
        pageId={pageId}
        buttonId={buttonId}
      >
        {content}
      </PageButton>
    );
  }

  return (
    <div className="daily-login-reward-history-item">
      {content}
    </div>
  );
}

export default DailyLoginRewardHistoryItem;
